
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { DownloadCloud, RefreshCw } from 'lucide-react';

interface TelemetryHeaderProps {
  lastUpdated: string;
  title?: string;
}

const TelemetryHeader: React.FC<TelemetryHeaderProps> = ({ 
  lastUpdated,
  title = 'Telemetry Dashboard'
}) => {
  const formatLastUpdated = (timestamp: string) => {
    try {
      const date = new Date(timestamp);
      return `${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`;
    } catch (error) {
      console.error('Error formatting timestamp:', error);
      return 'Unknown';
    }
  };

  return (
    <CardHeader className="pb-4">
      <div className="flex flex-col md:flex-row justify-between gap-2">
        <div>
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription>
            Last updated: {formatLastUpdated(lastUpdated)}
          </CardDescription>
        </div>
        
        <div className="flex gap-2">
          <Button variant="outline" size="sm">
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh
          </Button>
          <Button variant="outline" size="sm">
            <DownloadCloud className="h-4 w-4 mr-2" />
            Export
          </Button>
        </div>
      </div>
    </CardHeader>
  );
};

export default TelemetryHeader;
